import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Link as RouterLink } from 'react-router-dom';
import { EM_DASH } from 'libs.constants';
import { Link, Text, useLocalizeMessage } from 'libs.nucleus';
import { ActivityOrigin } from '../../types';
const TEXT_PROPS = {
    size: 'sm',
    className: 'text-text-secondary',
};
/**
 * Renders a label-value pair with consistent styling.
 */
const LabelValue = ({ label, value }) => (_jsxs(Text, { ...TEXT_PROPS, children: [label, ": ", value] }));
/**
 * Renders a link to the source activity with optional version number.
 */
const SourceLink = ({ link, name, version, destination, }) => (_jsxs(Link, { LinkComponent: RouterLink, to: `${link}#${destination}`, target: '_blank', rel: 'noopener noreferrer', children: [name, version && ` (v${version})`] }));
export const SourceActivityInfo = ({ activityOrigin, sourceLink, sourceActivityName, sourceActivityVersion, sourceId, sourceWorkspaceId, sourceWorkspaceName, destination = 'details', }) => {
    const t = useLocalizeMessage();
    // ORIGINAL: Created from scratch (new activity) - No source information shown
    if (activityOrigin === ActivityOrigin.ORIGINAL) {
        return _jsx(Text, { ...TEXT_PROPS, children: EM_DASH });
    }
    // CROSS_WORKSPACE_CLONED, VERSIONED, or CLONED: Show source activity information
    const isCrossWorkspace = activityOrigin === ActivityOrigin.CROSS_WORKSPACE_CLONED;
    const isVersioned = activityOrigin === ActivityOrigin.VERSIONED;
    const isCloned = activityOrigin === ActivityOrigin.CLONED;
    // Return null for unknown activity origins
    if (!isCrossWorkspace && !isVersioned && !isCloned) {
        return null;
    }
    const hasLinkableSource = (isVersioned || isCloned) && sourceLink && sourceActivityName;
    return (_jsxs("div", { className: 'flex flex-col gap-1', children: [sourceActivityName && (_jsxs("div", { className: 'flex gap-1', children: [_jsxs(Text, { ...TEXT_PROPS, children: [t('Name'), ":"] }), hasLinkableSource ? (_jsx(SourceLink, { link: sourceLink, name: sourceActivityName, version: sourceActivityVersion, destination: destination })) : (_jsxs(Text, { ...TEXT_PROPS, children: [sourceActivityName, sourceActivityVersion && ` (v${sourceActivityVersion})`] }))] })), sourceId && _jsx(LabelValue, { label: t('ID'), value: sourceId }), isCrossWorkspace && sourceWorkspaceName && (_jsx(LabelValue, { label: t('Workspace'), value: `${sourceWorkspaceName} (${sourceWorkspaceId})` }))] }));
};
//# sourceMappingURL=source_activity_info.component.js.map